export const INVALID_GRANT_ERROR_CODE = 'invalid_grant'
